<template>
  <div class="tw:bg-gray-100 tw:p-4 tw:flex tw:flex-row tw:items-center tw:gap-x-2 tw:rounded-xl">
    <div class="tw:bg-gray-300 tw:rounded-full tw:p-3">
      <img :src="icon" :alt="$t(title)" class="tw:h-6 tw:w-6" />
    </div>
    <div>
      <div class="tw:flex tw:items-center">
        <p class="tw:font-bold">{{ $t(title) }}</p>
        <UiTooltip tooltip-position="top" :label="hint" class="tw:cursor-pointer">
          <InformationOutline class="tw:fill-none tw:stroke-gray-500 tw:h-[16px] tw:w-[16px] tw:ml-1" />
        </UiTooltip>
      </div>
      <p class="tw:text-gray-600 tw:text-xs">{{ $t('performance_no_data') }}</p>
    </div>
  </div>
</template>
<script setup>
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

defineProps({
  icon: Object,
  title: String,
  hint: String,
})
</script>
